module.exports = __webpack_public_path__ + "static/img_4734-05c0030d7bb35f58be8e96d2417c0495.webp";